import { createFocusTrap } from 'focus-trap';

export default class NavigationMobile {
  constructor($el) {
    this.$el = $el;
    this.$mainItems = this.$el.querySelectorAll('.main-navigation__item');
    this.$mainLinks = this.$el.querySelectorAll('.main-navigation__item-link[aria-controls]');
    this.$subMenues = this.$el.querySelectorAll('.main-navigation__sub');
    this.$backSubmenues = this.$el.querySelectorAll('.main-navigation__sub-back');
  }

  init() {
    this.$mainLinks.forEach(($link) => {
      $link.addEventListener('click', this.submenueOpen);
    });

    this.$backSubmenues.forEach(($link) => {
      $link.addEventListener('click', this.submenueBack);
    });

    this.focusTraps = new Map();

    // Initialize the focus-trap for submenues
    this.$subMenues.forEach(($submenue) => {
      // Init focus trap
      const focusTrapTarget = $submenue;

      const focusTrap = createFocusTrap(focusTrapTarget, {
        escapeDeactivates: false,
        clickOutsideDeactivates: false,
        returnFocusOnDeactivate: false,
      });

      this.focusTraps.set(focusTrapTarget, focusTrap); // Store the focus trap for later use

      $submenue.setAttribute('inert', true);
      $submenue.setAttribute('aria-hidden', 'true');
    });
  }

  deInit() {
    this.$mainLinks.forEach(($link) => {
      $link.removeEventListener('click', this.submenueOpen);
    });

    this.$backSubmenues.forEach(($link) => {
      $link.removeEventListener('click', this.submenueBack);
    });
  }

  submenueOpen = (event) => {
    const controls = event.target.getAttribute('aria-controls');
    const expanded = event.target.getAttribute('aria-expanded');

    // close all the currently opened submenus
    this.$mainItems.forEach(($item) => {
      const itemControls = $item.querySelector('.main-navigation__item-link').getAttribute('aria-controls');
      if (itemControls && itemControls !== controls) {
        $item.classList.remove('open');
        document.getElementById(itemControls).classList.remove('open');
        $item.querySelector('.main-navigation__item-link').classList.remove('open');
        $item.querySelector('.main-navigation__item-link').setAttribute('aria-expanded', 'false');
      }
    });

    const $submenu = document.getElementById(controls);
    if ($submenu && expanded === 'false') {
      event.target.setAttribute('aria-expanded', 'true');
      $submenu.closest('.main-navigation__item').classList.add('open');
      $submenu.classList.add('open');

      // Enable focus trap
      const focusTrap = this.focusTraps.get($submenu);
      if (focusTrap) focusTrap.activate();

      $submenu.removeAttribute('inert');
      $submenu.removeAttribute('aria-hidden');
    } else if ($submenu && expanded === 'true') {
      event.target.setAttribute('aria-expanded', 'false');
      $submenu.closest('.main-navigation__item').classList.remove('open');
      $submenu.classList.remove('open');

      // Disable focus trap
      const focusTrap = this.focusTraps.get($submenu);
      if (focusTrap) focusTrap.deactivate();

      $submenu.setAttribute('inert', true);
      $submenu.setAttribute('aria-hidden', 'true');
    }
  }

  submenueBack = (event) => {
    const parentItem = event.target.closest('.main-navigation__item');
    const parentLink = parentItem.querySelector('.main-navigation__item-link');

    parentItem.classList.remove('open');
    const parentSubmenu = parentLink.getAttribute('aria-controls');
    const $submenu = document.getElementById(parentSubmenu);
    document.getElementById(parentSubmenu).classList.remove('open');
    parentLink.setAttribute('aria-expanded', 'false');

    // Disable focus trap
    const focusTrap = this.focusTraps.get($submenu);
    if (focusTrap) focusTrap.deactivate();

    $submenu.setAttribute('inert', true);
    $submenu.setAttribute('aria-hidden', 'true');
  }
}
